import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconVisible = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12ZM15.5 12C15.5 13.933 13.933 15.5 12 15.5C10.067 15.5 8.5 13.933 8.5 12C8.5 10.067 10.067 8.5 12 8.5C13.933 8.5 15.5 10.067 15.5 12Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 3.75C8.28497 3.75 5.5985 5.21584 3.84467 6.96967C2.97227 7.84207 2.33072 8.78514 1.90468 9.65426C1.48605 10.5083 1.25 11.3438 1.25 12C1.25 12.6562 1.48605 13.4917 1.90468 14.3457C2.33072 15.2149 2.97227 16.1579 3.84467 17.0303C5.5985 18.7842 8.28497 20.25 12 20.25C15.715 20.25 18.4015 18.7842 20.1553 17.0303C21.0277 16.1579 21.6693 15.2149 22.0953 14.3457C22.5139 13.4917 22.75 12.6562 22.75 12C22.75 11.3438 22.5139 10.5083 22.0953 9.65426C21.6693 8.78514 21.0277 7.84207 20.1553 6.96967C18.4015 5.21584 15.715 3.75 12 3.75ZM2.75 12C2.75 11.6562 2.88895 11.0542 3.25156 10.3145C3.60678 9.58986 4.15273 8.78293 4.90533 8.03033C6.4015 6.53416 8.71503 5.25 12 5.25C15.285 5.25 17.5985 6.53416 19.0947 8.03033C19.8473 8.78293 20.3932 9.58986 20.7484 10.3145C21.1111 11.0542 21.25 11.6562 21.25 12C21.25 12.3438 21.1111 12.9458 20.7484 13.6855C20.3932 14.4101 19.8473 15.2171 19.0947 15.9697C17.5985 17.4658 15.285 18.75 12 18.75C8.71503 18.75 6.4015 17.4658 4.90533 15.9697C4.15273 15.2171 3.60678 14.4101 3.25156 13.6855C2.88895 12.9458 2.75 12.3438 2.75 12Z",
		fill: "currentColor"
	})]
});
export { SvgIconVisible as ReactComponent };
